import React from 'react';

const BusinessLoanForm = () => {
    return (
        <form className='text-daborder-dashedrk'>
            {/* // x---------------------------------x Personal Information Section // x---------------------------------x  */}
            <div className="py-4 pt-0">
                <h4 className="md:text-2xl font-medium mb-3">Personal Information</h4>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                        <label htmlFor="fullName" className="block mb-1 text-sm font-medium">Full Name</label>
                        <input type="text" className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0"
                            id="fullName" placeholder="John Doe" required />
                    </div>
                    <div>
                        <label htmlFor="dob" className="block mb-1 text-sm font-medium ">Daborder-dashedte of Birth</label>
                        <input type="text" className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0"
                            id="dob" placeholder='DD-MM-YY' required />
                    </div>
                    <div>
                        <label htmlFor="email" className="block mb-1 text-sm font-medium">Email Address</label>
                        <input type="email" name='emailname' className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0"
                            id="email" placeholder="john.doe@example.com" required autoComplete='off' />
                    </div>
                    <div>
                        <label htmlFor="phoneNumber" className="block mb-1 text-sm font-medium">Phone Number</label>
                        <input type="tel" className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0"
                            id="phoneNumber" placeholder="+1 234 567 8900" required />
                    </div>
                    <div className="md:col-span-2">
                        <label htmlFor="address" className="block mb-1 text-sm font-medium">Residential Address</label>
                        <textarea className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0"
                            autoComplete='off' id="address" name='address' rows="3" placeholder="123 Main St, Apt 4B, City, State, ZIP" required></textarea>
                    </div>
                </div>
            </div>

            {/* // x---------------------------------x Employment Information Section x---------------------------------x  */}
            <div className="py-4">
                <h4 className="md:text-2xl font-medium mb-3">Employment Information</h4>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                        <label htmlFor="employer" className="block mb-1 text-sm font-medium">Employer</label>
                        <input type="text" className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0"
                            id="employer" placeholder="ABC Corp" required />
                    </div>
                    <div>
                        <label htmlFor="jobTitle" className="block mb-1 text-sm font-medium">Job Title</label>
                        <input type="text" className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0"
                            id="jobTitle" placeholder="Software Engineer" required />
                    </div>
                    <div>
                        <label htmlFor="annualIncome" className="block mb-1 text-sm font-medium">Annual Income</label>
                        <input type="number" className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0"
                            id="annualIncome" placeholder="50000" required />
                    </div>
                </div>
            </div>

            {/* x---------------------------------x Loan Details Section x---------------------------------x */}
            <div className="py-4">
                <h4 className="md:text-2xl font-medium mb-3">Loan Details</h4>
                <div className="grid grid-cols-1 gap-4">
                    <div>
                        <label htmlFor="loanAmount" className="block mb-1 text-sm font-medium">Loan Amount Requested</label>
                        <input type="number" className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0"
                            id="loanAmount" placeholder="10000" required />
                    </div>
                    <div>
                        <label htmlFor="loanPurpose" className="block mb-1 text-sm font-medium">Purpose of Loan</label>
                        <textarea className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0"
                            id="loanPurpose" rows="3" placeholder="Home renovation, debt consolidaborder-dashedtion, etc." required></textarea>
                    </div>
                    <div>
                        <label htmlFor="loanTerm" className="block mb-1 text-sm font-medium">Loan Term</label>
                        <select className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0" id="loanTerm" required defaultValue={'DEFAULT'}>
                            <option value="DEFAULT" disabled>Select term</option>
                            <option value="12">12 months</option>
                            <option value="24">24 months</option>
                            <option value="36">36 months</option>
                            <option value="48">48 months</option>
                            <option value="60">60 months</option>
                        </select>
                    </div>
                </div>
            </div>

            {/* x---------------------------------x conditions and Submit Section  x---------------------------------x */}
            <div className='flex flex-col'>
                <div className="mb-4 flex items-center gap-2">
                    <input type="checkbox" id="consent" required
                        className="h-4 w-4 text-primary border-gray-300 rounded focus:ring-primary" />
                    <label className="text-sm" htmlFor="consent">I agree to the terms and conditions.</label>
                </div>
                <div>
                    <button type="submit" className="bg-primary-900 text-white hover:bg-primary-800 rounded-lg py-2 px-4 w-full md:w-auto">
                        Submit Application
                    </button>
                </div>
            </div>
        </form>
    );
};

export default BusinessLoanForm;
